import {Alert} from '../functions'

(function ($) {
    $(document).ready(function () {

        /* Contact Form */
        (function () {
            "use strict";

            // definition des parametres de base du plugin
            var options = {
                mail_input_name: 'email',
                retour_message: '.retour_message',
                action: null
            }

            /**
             * @param change_options
             */
            $.fn.VnAjaxForm = function (change_options) {
                //copy options variable to not overide it
                var option = $.extend(true, {}, options);
                // surcharge main options
                if (change_options) {
                    option = $.extend(option, change_options);
                }
                //get form
                var form = $(this);
                //select div to insert into callback message
                var message_container = form.parent().find(option.retour_message);

                option = loadParameters(form, option);

                if (undefined === option.action) {
                    // alertify.message('No action defined, please contact an administrator');
                    Alert('error', 'No action defined, please contact an administrator')
                    return null;
                }

                var timeOut = null; // evite le retour directe du formulaire
                form.submit(function (event) {
                    timeOut = setTimeout(function () {
                        clearInterval(timeOut);
                        message_container.empty(); //on vide le message
                        if (form[0].checkValidity() === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            Alert('error', onscObject.require_filed)
                        } else {
                            var formData = new FormData(form[0]);
                            formData.append('action', option.action);
                            var message_send = null;
                            $.ajax({
                                type: 'POST',
                                url: onscObject.ajaxUrl,
                                data: formData,
                                contentType: false,
                                processData: false,
                                dataType: "json",
                                // async:false,
                                beforeSend: function () {
                                    var send_point = '...';
                                    var index = 0;

                                    message_send = Alert('info', onscObject.send_form_message + ' ' + send_point.substring(0, index % 4))
                                },
                                success: function (jSon_message) {
                                    Alert('success', jSon_message.data.message)
                                    if (jSon_message.success === true) {
                                        clearForm(form);
                                        if (jSon_message.data.thanks_page_url !== '' && jSon_message.data.thanks_page_url !== undefined) {
                                            setTimeout(function () {
                                                location.href = jSon_message.data.thanks_page_url;
                                            }, 1000);
                                        }
                                    }
                                },
                                error: function (data) {
                                    Alert('error', onscObject.error)
                                },
                                complete: function () {
                                    message_send.dismiss();
                                }
                            });
                        }
                        form.addClass('was-validated');
                    }, 200);


                    event.preventDefault();
                    event.stopPropagation();
                });
            };

            //set default params
            function loadParameters(element, option) {
                if (option.action === null) {
                    option.action = $(element).attr('action');
                }
                return option;
            }

            $('.send-form-with-vn-ajax-form').each(function () {
                $(this).VnAjaxForm();
            });
        })();

        function clearForm(form) {
            $(':input', form)
                .not(':button, :submit, :reset, :hidden')
                .val('')
                .prop('checked', false)
                .prop('selected', false);

            form.removeClass('was-validated');
        }
    })
})(jQuery)
